import React, { useState, Fragment, useRef } from "react";
import { useLocation, useHistory } from "react-router-dom";
import axios from "axios";
import toast from "react-hot-toast";
import { Formik, Form, Field } from "formik";
import "../../static/css/vacante.css";
import $ from "jquery";
import * as Yup from "yup";
import edit_solid from "../../static/images/ana/edit-solid.svg";
import useOnceEffect from "../../Hooks/useOnceEffect";
import Swal from "sweetalert2";
import { Modal } from "react-bootstrap";
import useToggle from "../../Hooks/useToggle";
import { colors } from "@material-ui/core";
import download from "downloadjs";
import LinkButton from "../../utils/LinkButton";
import Select from "react-select";
import { sortObjectArray } from "../../utils/Sort";

const initialValues = {
  archivotest: null,
  archivotestNombre: "",
  archivotestURL: "",
  archivotestcampany: "",
  companyVacantId: 0,
  description: "",
};

function Vacante() {
  let userId = localStorage.getItem("userId");
  const [loading, setLoading] = useState(true);
  const [company, setcompany] = useState("");
  const [contractList, setcontractList] = useState([]);
  const [experienceList, setexperienceList] = useState([]);
  const [tipoempleoList, settipoempleoList] = useState([]);
  const [tipojornadaList, settipojornadaList] = useState([]);
  const [listaDepartamentos, setlistaDepartamentos] = useState([]);
  const [listMoneda, setlistMoneda] = useState([]);
  const [listIdiomas, setlistIdiomas] = useState([]);
  const [idiomasSelected, setidiomasSelected] = useState([]);
  const [listHabilidades, setlistHabilidades] = useState([]);
  const [habilidadesSelected, sethabilidadesSelected] = useState([]);
  const [areaList, setareaList] = useState([]);
  const [test1, setTest] = useState(initialValues);
  const [testd, setTestd] = useState("");
  const history = useHistory();

  const [vacant, setvacant] = useState("");
  const [labelStep, setlabelStep] = useState("");
  const location = useLocation();
  const [date] = useState(new Date());
  const testExiste = useRef(false);
  const [Notatest, Setnotatest] = useState(false);
  const [testM, toggleTest] = useToggle(false);

  const [testdes, settestdes] = useState("");

  let rol = localStorage.getItem("rol");
  let pathComplement = "";
  if (rol === "company") pathComplement = "/company";
  else pathComplement = "/CentroFormacion";

  const LoadEditarVacante = () => {
    axios.get("company-vacant/" + location.state.vacantId).then((result) => {
      setvacant(result.data);
    });
  };

  //Obtener lista de contratos
  const ContractList = () => {
    axios.get("contract/list-contracts").then((result) => {
      setcontractList(result.data);
    });
  };

  //Obtenemos informacion de la empresa
  const LoadCompany = () => {
    axios.get("access/company/" + userId).then((result) => {
      setcompany(result.data);
      // setLoading(false);
    });
  };

  //Obtenemos lista nivel de experiencia
  const LoadNivelExp = () => {
    axios.get("nivel-exp/list").then((result) => {
      setexperienceList(result.data);
    });
  };

  //Obtenemos lista tipos de empleos
  const LoadTipoEmpleo = () => {
    axios.get("tipo-empleo/list").then((result) => {
      settipoempleoList(result.data);
    });
  };

  //Obtenemos lista tipo jornada
  const LoadTipoJornada = () => {
    axios.get("tipo-jornada/list").then((result) => {
      settipojornadaList(result.data);
    });
  };

  //Obtenemos lista de departamentos
  const LoadDepartamentoList = () => {
    axios.get("department-list").then((result) => {
      setlistaDepartamentos(result.data);
      setLoading(false);
    });
  };

  const LoadMonedas = () => {
    axios.get("company-vacant/list-monedas").then((result) => {
      setlistMoneda(result.data);
    });
  };

  //Obtenemos lista de idiomas
  const ListLenguajes = () => {
    axios.get("applicant-languages/list-language/").then((result) => {
      setlistIdiomas(result.data);
    });
  };

  //Obtenemos listado de habilidades
  const ListSkills = () => {
    axios.get("skills/list-skills").then((result) => {
      setlistHabilidades(result.data);
    });
  };

  const getArea = () => {
    axios.get("access/areas").then((result) => {
      if (result.status === 200) {
        setareaList(result.data);
      } else if (result.status == 400) {
        toast.error(
          result.errors[0].field + " " + result.errors[0].defaultMessage
        );
      } else toast.error(result.message);
    });
  };

  const getVacantTest = () => {
    axios
      .get("company-vacant-test/test-by-vacant", {
        params: {
          companyVacantId: location.state.vacantId,
        },
      })
      .then((res) => {
        if (res.data.message === "1") {
          testExiste.current = true;
          Setnotatest(true);
        }
      });
  };

  const Downloadtestvacant = () => {
    axios
      .get(
        "company-vacant-test/download-file?companyVacantId=" +
          location.state.vacantId,
        {
          responseType: "blob", // had to add this one here
        }
      )
      .then((result) => {
        if (result.status === 200) {
          const content = result.headers["content-type"];
          download(
            result.data,
            result.headers["filename"] ?? "Test.pdf",
            content
          );

          toast.success("Descargando", {
            duration: 4000,
          });
        } else if (result.status === 400) {
          toast.error(
            result.errors[0].field + " " + result.errors[0].defaultMessage
          );
        } else toast.error(result.message);
      })
      .catch((e) => {
        if (!e.status) {
          toast.error("No hay Test Disponible", { duration: 5000 });
        }
      });
  };

  const getdescripciontest = () => {
    axios
      .get("/company-vacant-test/description-test-by-vacant", {
        params: {
          companyVacantId: location.state.vacantId,
        },
      })
      .then((result) => {
        settestdes(result.data);
      });
  };

  const LoadData = async () => {
    ContractList();
    LoadCompany();
    LoadNivelExp();
    LoadTipoEmpleo();
    LoadTipoJornada();
    LoadDepartamentoList();
    LoadMonedas();
    getArea();

    if (location.state !== undefined) {
      getdescripciontest();
      getVacantTest();
      LoadEditarVacante();
      const data = await axios.get("company-vacant/" + location.state.vacantId);
      setvacant(data.data);
      SetHabilidadeseIdiomas(data.data);
    }

    ListLenguajes();
    ListSkills();
  };

  const paintProgress = (porc) => {
    const bar = document.getElementById("line-progress");
    switch (porc) {
      case 1:
        bar.style = "width: 0%;";
        let s1 = document.getElementsByClassName("stepA1");
        s1[0].className.search("active") > 0
          ? (s1[0].className = "step stepA1")
          : (s1[0].className = "step stepA1 active");
        break;
      case 2:
        bar.style = "width: 21.66%;";
        let s2 = document.getElementsByClassName("stepA2");
        s2[0].className.search("active") > 0
          ? (s2[0].className = "step stepA2")
          : (s2[0].className = "step stepA2 active");
        break;
      case 3:
        bar.style = "width: 45.66%;";
        let s3 = document.getElementsByClassName("stepA3");
        s3[0].className.search("active") > 0
          ? (s3[0].className = "step stepA3")
          : (s3[0].className = "step stepA3 active");
        break;
      case 4:
        bar.style = "width: 70.66%;";
        let s4 = document.getElementsByClassName("stepA4");
        s4[0].className.search("active") > 0
          ? (s4[0].className = "step stepA4")
          : (s4[0].className = "step stepA4 active");
        break;
      case 5:
        bar.style = "width: 99.66%;";
        let s5 = document.getElementsByClassName("stepA5");
        s5[0].className.search("active") > 0
          ? (s5[0].className = "step stepA5")
          : (s5[0].className = "step stepA5 active");
        break;
      default:
        break;
    }
  };

  function GuardarVacante(values, reset) {
    let vacante = {
      acercaVacante: values.acercaVacante,
      beneficios: values.beneficios,
      cargo: values.cargo,
      comentarios: values.comentarios,
      companyId: company.companyProfileId,
      companyVacantId: 0,
      contractId: values.contractId,
      departmentId: values.departmentId,
      monedaId: values.moneda,
      esVacante: true,
      esVigente: true,
      fechaPublicacion: new Date().toISOString(),
      listEtapasVacante: [
        {
          estadoId: 0,
          nombreEtapa: document.getElementById("etapa1").innerText,
          orden: 1,
          vacanteEmpresaId: 0,
        },
        {
          estadoId: 0,
          nombreEtapa: document.getElementById("etapa2").innerText,
          orden: 2,
          vacanteEmpresaId: 0,
        },
        {
          estadoId: 0,
          nombreEtapa: document.getElementById("etapa3").innerText,
          orden: 3,
          vacanteEmpresaId: 0,
        },
        {
          estadoId: 0,
          nombreEtapa: document.getElementById("etapa4").innerText,
          orden: 4,
          vacanteEmpresaId: 0,
        },
        {
          estadoId: 0,
          nombreEtapa: document.getElementById("etapa5").innerText,
          orden: 5,
          vacanteEmpresaId: 0,
        },
      ],
      listLanguageVacante: ArrIdioma(),
      listSkillVacante: ArrHabilidad(),
      motocicleta: values.moticicleta,
      nivelExperienciaEmpleoId: values.nivelExperienciaEmpleoId,
      salario: values.salario,
      sectorId: company.sectorId.sectorId,
      tipoJornadaId: values.tipoJornadaId,
      typeEmployeeId: values.typeEmployeeId,
      vehiculo: values.vehiculo,
      areaId: values.areaId,
    };
    axios
      .post("company-vacant/create", vacante)
      .then((result) => {
        if (result.status == 200) {
          toast.success("Vacante creada exitosamente!", {
            duration: 6000,
          });
          reset();
          setidiomasSelected([]);
          sethabilidadesSelected([]);
        }
      })
      .catch(function (error) {
        if (error.response.status == 403) {
          toast.error(
            "Su usuario no esta autorizado para realizar esta accion, para mayor informacion contactar al administrador"
          );
        }
        if (error.response.status == 400) {
          toast.error(error.response.data.message);
        }
      });
  }

  function SetEtapa(event) {
    const { value } = event.target;
    let lbl = document.getElementById(labelStep);
    lbl.innerText = value;
  }

  function ActualizarVacante(values) {
    let arr = [];
    if (document.getElementById("etapa3") !== null) {
      arr = [
        {
          completado:
            document
              .getElementById("etapa1")
              .parentElement.parentElement.className.search("active") > 0
              ? true
              : false,
          estadoId: vacant.listEtapasVacante[0]?.idEtapaVacante ?? 0,
          nombreEtapa: document.getElementById("etapa1").innerText,
          orden: 1,
          vacanteEmpresaId: vacant.companyVacant?.companyVacantId ?? 0,
        },
        {
          completado:
            document
              .getElementById("etapa2")
              .parentElement.parentElement.className.search("active") > 0
              ? true
              : false,
          estadoId: vacant.listEtapasVacante[1]?.idEtapaVacante ?? 0,
          nombreEtapa: document.getElementById("etapa2").innerText,
          orden: 2,
          vacanteEmpresaId: vacant.companyVacant?.companyVacantId ?? 0,
        },
        {
          completado:
            document
              .getElementById("etapa3")
              .parentElement.parentElement.className.search("active") > 0
              ? true
              : false,
          estadoId: vacant.listEtapasVacante[2]?.idEtapaVacante ?? 0,
          nombreEtapa: document.getElementById("etapa3").innerText,
          orden: 3,
          vacanteEmpresaId: vacant.companyVacant?.companyVacantId ?? 0,
        },
        {
          completado:
            document
              .getElementById("etapa4")
              .parentElement.parentElement.className.search("active") > 0
              ? true
              : false,
          estadoId: vacant.listEtapasVacante[3]?.idEtapaVacante ?? 0,
          nombreEtapa: document.getElementById("etapa4").innerText,
          orden: 4,
          vacanteEmpresaId: vacant.companyVacant?.companyVacantId ?? 0,
        },
        {
          completado:
            document
              .getElementById("etapa5")
              .parentElement.parentElement.className.search("active") > 0
              ? true
              : false,
          estadoId: vacant.listEtapasVacante[4]?.idEtapaVacante ?? 0,
          nombreEtapa: document.getElementById("etapa5").innerText,
          orden: 5,
          vacanteEmpresaId: vacant.companyVacant?.companyVacantId ?? 0,
        },
      ];
    } else {
      arr = [
        {
          completado: false,
          estadoId: vacant.listEtapasVacante[0]?.idEtapaVacante ?? 0,
          nombreEtapa: document.getElementById("etapa1").innerText,
          orden: 1,
          vacanteEmpresaId: vacant.companyVacant?.companyVacantId ?? 0,
        },
        {
          completado: false,
          estadoId: vacant.listEtapasVacante[1]?.idEtapaVacante ?? 0,
          nombreEtapa: document.getElementById("etapa2").innerText,
          orden: 2,
          vacanteEmpresaId: vacant.companyVacant?.companyVacantId ?? 0,
        },
      ];
    }

    let vacante = {
      acercaVacante: values.acercaVacante,
      beneficios: values.beneficios,
      cargo: values.cargo,
      comentarios: values.comentarios,
      companyId: company.companyProfileId,
      companyVacantId: vacant.companyVacant?.companyVacantId ?? 0,
      contractId: values.contractId,
      departmentId: values.departmentId,
      esVacante: true,
      esVigente: true,
      fechaPublicacion: values.fechaPublicacion,
      listEtapasVacante: arr,
      monedaId: values.moneda,
      areaId: values.areaId,
      listLanguageVacante: ArrIdioma(),
      listSkillVacante: ArrHabilidad(),
      moticicleta: values.moticicleta,
      nivelExperienciaEmpleoId: values.nivelExperienciaEmpleoId,
      salario: values.salario,
      sectorId: company.sectorId.sectorId,
      tipoJornadaId: values.tipoJornadaId,
      typeEmployeeId: values.typeEmployeeId,
      vehiculo: values.vehiculo,
    };

    axios
      .post("company-vacant/update", vacante)
      .then((result) => {
        if (result.status == 200) {
          toast.success("Vacante actualizada exitosamente!", {
            duration: 6000,
          });
        }
      })
      .catch(function (error) {
        if (error.response.status == 403) {
          toast.error(
            "Su usuario no esta autorizado para realizar esta accion, para mayor informacion contactar al administrador"
          );
        }
        if (error.response.status == 400) {
          toast.error(error.response.data.message);
        }
      });
  }

  function ArrIdioma() {
    return idiomasSelected.map((item) => {
      return {
        laguagueId: item.id,
        laguagueVacantId: 0,
        vacanteEmpresaId: 0,
      };
    });
  }

  function SelectIdioma(value) {
    value = parseInt(value);
    $("#agregar-idioma-vacante-modal").modal("hide");

    let filter = idiomasSelected.find((x) => parseInt(x.id) === value);

    if (filter !== undefined) {
      toast.error("Idioma ya seleccionado");
      return;
    }

    let idioma = listIdiomas.find((x) => parseInt(x.id) === value);

    if (idioma === undefined) {
      toast.error("Idioma no encontrado");
      return;
    }

    setidiomasSelected([...idiomasSelected, idioma]);
  }

  function ArrHabilidad() {
    return habilidadesSelected.map((item) => {
      return {
        skillId: item.skillId,
        skillVacantId: 0,
        vacanteEmpresaId: 0,
      };
    });
  }

  function SelectHabilidad(value) {
    value = parseInt(value);

    $("#agregar-habilidad-vacante-modal").modal("hide");

    let filter = habilidadesSelected.find((x) => parseInt(x.skillId) === value);

    if (filter !== undefined) {
      toast.error("Habilidad ya seleccionado");
      return;
    }

    let habilidad = listHabilidades.find((x) => parseInt(x.skillId) === value);

    if (habilidad !== undefined) {
      sethabilidadesSelected([...habilidadesSelected, habilidad]);
      return;
    }

    toast.error("Habilidad no encontrada");
  }

  const SetHabilidadeseIdiomas = async (data) => {
    const skillList = await axios.get("skills/list-skills");
    setlistHabilidades(skillList.data);

    const listIdiomas = await axios.get("applicant-languages/list-language/");
    setlistIdiomas(listIdiomas.data);

    if (data?.listSkills instanceof Array) {
      let selected = [];

      data.listSkills.forEach((item) => {
        let skill = skillList.data.find((x) => x.skillId === item.skillId);

        selected.push(skill);
      });

      sethabilidadesSelected([...selected]);

      selected = [];

      data.listIdiomas.forEach((item) => {
        let idioma = listIdiomas.data.find((x) => x.id === item.languageId);
        selected.push(idioma);
      });

      setidiomasSelected([...selected]);
    }
  };

  const fileSelectHandler = (e) => {
    let {
      target: { files },
    } = e;

    setTest(files[0]);
  };

  const onSubmit = (e) => {
    e.preventDefault();

    function localConfirm() {
      const data = new FormData();

      //dumping required data
      data.append("File", test1);
      data.append(
        "companyVacantId",
        vacant.companyVacant?.companyVacantId ?? 0
      );
      data.append("typeTestId", 1);
      data.append("Description", testd.description);

      axios
        .post("company-vacant-test/upload-file", data)
        .then((result) => {
          if (result.status === 200) {
            toast.success("Archivo subido", {
              duration: 6000,
            });
            $("#Subir-test").modal("hide");
          }
        })
        .catch(function (error) {
          if (error.response.status === 400) {
            toast.error("Agregar Test");
          }
        });
    }

    if (!testExiste.current) {
      localConfirm();
      return;
    }

    Swal.fire({
      text: "Ya existe un archivo para las pruebas, ¿Quieres reemplazarlo?",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Si",
      cancelButtonText: "No",
    }).then((res) => {
      if (res.isConfirmed) {
        localConfirm();
      }
    });
  };

  const Validaciones = Yup.object().shape({
    acercaVacante: Yup.string()
      .required("No puede estar vacio")
      .min(3, "No puede tener menos de 3 caracteres"),
    beneficios: Yup.string()
      .required("No puede estar vacio")
      .min(3, "No puede tener menos de 3 caracteres"),
    cargo: Yup.string()
      .required("No puede estar vacio")
      .min(3, "No puede tener menos de 3 caracteres")
      .max(60, "No puede tener mas de 60 caracteres"),
    comentarios: Yup.string()
      .required("No puede estar vacio")
      .min(3, "No puede tener menos de 3 caracteres"),
    moneda: Yup.number().required("Seleccione una moneda"),
    contractId: Yup.number().required("Seleccione tipo de contrato"),
    departmentId: Yup.number().required("Seleccione ubicación"),
    typeEmployeeId: Yup.number().required("Seleccione tipo de empleo"),
    tipoJornadaId: Yup.number().required("Seleccione tipo de jornada"),
    nivelExperienciaEmpleoId: Yup.number().required(
      "Seleccione nivel de experiencia"
    ),
    areaId: Yup.string().required("Seleccione una opcion"),
  });

  useOnceEffect(() => {
    LoadData();
  });

  return (
    <Fragment>
      {loading ? (
        <label className="login-label">CARGANDO</label>
      ) : (
        <Formik
          enableReinitialize={true}
          initialValues={{
            acercaVacante: vacant.companyVacant?.acercaVacante ?? "",
            beneficios: vacant.companyVacant?.beneficios ?? "",
            cargo: vacant.companyVacant?.cargo ?? "",
            comentarios: vacant.companyVacant?.comentarios ?? "",
            contractId: vacant.companyVacant?.contractId.contractId ?? "",
            fechaPublicacion: new Date().toISOString(),
            moticicleta: vacant.companyVacant?.motocicleta ?? false,
            salario: vacant.companyVacant?.salario ?? 0,
            vehiculo: vacant.companyVacant?.vehiculo ?? false,
            nivelExperienciaEmpleoId:
              vacant.companyVacant?.nivelExperienciaEmpleoId
                .nivelExperienciaId ?? "",
            typeEmployeeId:
              vacant.companyVacant?.typeEmployeeId.typeEmployeeId ?? "",
            tipoJornadaId:
              vacant.companyVacant?.tipoJornadaId.tipoJornadaId ?? "",
            departmentId: vacant.companyVacant?.departmentId.departmentId ?? "",
            moneda: vacant.companyVacant?.monedaId.idMoneda ?? "",
            areaId: vacant.companyVacant?.areaId.areaId ?? "",
          }}
          onSubmit={(values, { setSubmitting, resetForm }) => {
            setSubmitting(true);

            setSubmitting(false);

            if (location.state !== undefined) {
              ActualizarVacante(values);
            } else {
              GuardarVacante(values, resetForm);
            }
          }}
          validationSchema={Validaciones}
        >
          {({ errors, touched, isSubmitting }) => (
            <Form>
              <div className="content" style={{ width: "100%" }}>
                <div className="tab-content" id="pills-tabContent">
                  <div
                    className="tab-pane fade show active"
                    id="pills-home"
                    role="tabpanel"
                    aria-labelledby="pills-tab1"
                  >
                    <div className="row">
                      <div className="col">
                        <h6>Información</h6>
                      </div>
                    </div>
                    <div className="row mt-4">
                      <div className="col-xs-12 col-md-3">
                        <div className="mb-3">
                          <label htmlFor="cargo" className="form-label">
                            Cargo/Puesto:
                          </label>
                          <Field
                            type="text"
                            name="cargo"
                            id="cargo"
                            className="form-control"
                            required
                          ></Field>
                          {errors.cargo && touched.cargo && (
                            <span className="form__validation form__validation--error">
                              {errors.cargo}
                            </span>
                          )}
                        </div>
                      </div>
                      <div className="col-xs-12 col-md-3">
                        <div className="mb-3">
                          <label
                            htmlFor="exampleFormControlInput1"
                            className="form-label"
                          >
                            Area
                          </label>
                          <Field
                            as="select"
                            name="areaId"
                            id="areaId"
                            required
                            className="form-select"
                          >
                            <option hidden selected>
                              Seleccione un area
                            </option>
                            {areaList.map((item) => {
                              return (
                                <option key={item.areaId} value={item.areaId}>
                                  {item.nombre}
                                </option>
                              );
                            })}
                          </Field>
                          {errors.areaId && touched.areaId && (
                            <span className="form__validation form__validation--error">
                              {errors.areaId}
                            </span>
                          )}
                        </div>
                      </div>
                      <div className="col-xs-12 col-md-3">
                        <div className="mb-3">
                          <label
                            htmlFor="exampleFormControlInput1"
                            className="form-label"
                          >
                            Ubicación
                          </label>
                          <Field
                            as="select"
                            type="text"
                            name="departmentId"
                            id="departmentId"
                            required
                            className="form-select"
                          >
                            <option hidden>Ubicación</option>
                            {listaDepartamentos.map((item, index) => {
                              return (
                                <option key={index} value={item.departmentId}>
                                  {item.name}
                                </option>
                              );
                            })}
                          </Field>
                          {errors.departmentId && touched.departmentId && (
                            <span className="form__validation form__validation--error">
                              {errors.departmentId}
                            </span>
                          )}
                        </div>
                      </div>
                      <div className="col-xs-12 col-md-3">
                        <div className="mb-3">
                          <label
                            htmlFor="exampleFormControlInput1"
                            className="form-label"
                          >
                            Tipo de Empleo
                          </label>
                          <Field
                            as="select"
                            type="text"
                            name="typeEmployeeId"
                            id="typeEmployeeId"
                            required
                            className="form-select"
                          >
                            <option hidden>Tipo de Empleo</option>
                            {tipoempleoList.map((item, index) => {
                              return (
                                <option key={index} value={item.typeEmployeeId}>
                                  {item.name}
                                </option>
                              );
                            })}
                          </Field>
                          {errors.typeEmployeeId && touched.typeEmployeeId && (
                            <span className="form__validation form__validation--error">
                              {errors.typeEmployeeId}
                            </span>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="row mt-2">
                    <div className="col-xs-12 col-md-3">
                      <div className="mb-3">
                        <label
                          htmlFor="exampleFormControlInput1"
                          className="form-label"
                        >
                          Tipo de Jornada
                        </label>
                        <Field
                          as="select"
                          type="text"
                          name="tipoJornadaId"
                          id="tipoJornadaId"
                          required
                          className="form-select"
                        >
                          <option hidden>Tipo de Jornada</option>
                          {tipojornadaList.map((item, index) => {
                            return (
                              <option key={index} value={item.tipoJornadaId}>
                                {item.name}
                              </option>
                            );
                          })}
                        </Field>
                        {errors.tipoJornadaId && touched.tipoJornadaId && (
                          <span className="form__validation form__validation--error">
                            {errors.tipoJornadaId}
                          </span>
                        )}
                      </div>
                    </div>
                    <div className="col-xs-12 col-md-3">
                      <div className="mb-3">
                        <label
                          htmlFor="exampleFormControlInput1"
                          className="form-label"
                        >
                          Tipo de Contrato
                        </label>
                        <Field
                          as="select"
                          name="contractId"
                          id="contractId"
                          required
                          className="form-select"
                        >
                          <option hidden>Tipo de Contrato</option>
                          {contractList.map((item, index) => {
                            return (
                              <option key={index} value={item.contractId}>
                                {item.name}
                              </option>
                            );
                          })}
                        </Field>
                        {errors.contractId && touched.contractId && (
                          <span className="form__validation form__validation--error">
                            {errors.contractId}
                          </span>
                        )}
                      </div>
                    </div>
                    <div className="col-xs-12 col-md-3">
                      <div className="mb-3">
                        <label
                          htmlFor="exampleFormControlInput1"
                          className="form-label"
                        >
                          Moneda
                        </label>
                        <Field
                          as="select"
                          name="moneda"
                          id="moneda"
                          required
                          className="form-select form-select-sm"
                        >
                          <option hidden>Denominacion</option>
                          {listMoneda.map((item, index) => {
                            return (
                              <option key={index} value={item.idMoneda}>
                                {item.description}
                              </option>
                            );
                          })}
                        </Field>
                        {errors.moneda && touched.moneda && (
                          <span className="form__validation form__validation--error">
                            {errors.moneda}
                          </span>
                        )}
                      </div>
                    </div>

                    <div className="col-xs-12 col-md-3">
                      <div className="mb-3">
                        <label
                          htmlFor="exampleFormControlInput1"
                          className="form-label"
                        >
                          Salario Estimado
                        </label>
                        <Field
                          type="number"
                          name="salario"
                          id="salario"
                          required
                          className="form-control"
                        ></Field>
                        {errors.salario && touched.salario && (
                          <span className="form__validation form__validation--error">
                            {errors.salario}
                          </span>
                        )}
                      </div>
                    </div>
                    <div className="col-xs-12 col-md-3">
                      <div className="mb-3">
                        <label
                          htmlFor="exampleFormControlInput1"
                          className="form-label"
                        >
                          Nivel de Experiencia
                        </label>
                        <Field
                          as="select"
                          type="text"
                          name="nivelExperienciaEmpleoId"
                          id="nivelExperienciaEmpleoId"
                          required
                          className="form-select"
                        >
                          <option hidden>Nivel de Experiencia</option>
                          {experienceList.map((item, index) => {
                            return (
                              <option
                                key={index}
                                value={item.nivelExperienciaId}
                              >
                                {item.name}
                              </option>
                            );
                          })}
                        </Field>
                        {errors.nivelExperienciaEmpleoId &&
                          touched.nivelExperienciaEmpleoId && (
                            <span className="form__validation form__validation--error">
                              {errors.nivelExperienciaEmpleoId}
                            </span>
                          )}
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-12">
                      <div className="form-check form-check-inline">
                        <Field
                          type="checkbox"
                          name="moticicleta"
                          id="moticicleta"
                          className="form-check-input"
                        ></Field>
                        {errors.moticicleta && touched.moticicleta && (
                          <span className="form__validation form__validation--error">
                            {errors.moticicleta}
                          </span>
                        )}
                        <label
                          className="form-check-label"
                          htmlFor="inlineCheckbox1"
                        >
                          Motocicleta
                        </label>
                      </div>
                      <div className="form-check form-check-inline">
                        <Field
                          type="checkbox"
                          name="vehiculo"
                          className="form-check-input"
                          id="vehiculo"
                        ></Field>
                        {errors.vehiculo && touched.vehiculo && (
                          <span className="form__validation form__validation--error">
                            {errors.vehiculo}
                          </span>
                        )}
                        <label className="form-check-label" htmlFor="vehiculo">
                          Vehículo
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row mt-5">
                  <div className="col">
                    <h6>Descripción</h6>
                    <p className="mt-4">Acerca de la Vacante</p>
                    <div className="m-st">
                      <Field
                        as="textarea"
                        name="acercaVacante"
                        id="acercaVacante"
                        className="form-control"
                        required
                      ></Field>
                      {errors.acercaVacante && touched.acercaVacante && (
                        <span className="form__validation form__validation--error">
                          {errors.acercaVacante}
                        </span>
                      )}
                    </div>
                  </div>
                </div>

                {/* Habilidades | Idiomas*/}
                <div className="row">
                  <div className="col-md-6">
                    <p className="m-st">Habilidades y Aptitudes</p>
                    <div
                      className="mb-3 btn-box"
                      data-bs-toggle="modal"
                      data-bs-target="#agregar-habilidad-vacante-modal"
                    >
                      <div className="row">
                        {habilidadesSelected &&
                          habilidadesSelected.map((item, index) => {
                            return (
                              <div key={index} className="col">
                                <div
                                  className="alert alert-dark alert-dismissible fade show"
                                  role="alert"
                                  style={{ width: "145px" }}
                                >
                                  {item.name}
                                  <button
                                    type="button"
                                    className="btn-close"
                                    data-bs-dismiss="alert"
                                    aria-label="Close"
                                  ></button>
                                </div>
                              </div>
                            );
                          })}
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <p className="m-st">Idiomas</p>
                    <div
                      className="mb-3 btn-box"
                      data-bs-toggle="modal"
                      data-bs-target="#agregar-idioma-vacante-modal"
                    >
                      <div className="row">
                        {idiomasSelected.map((item, index) => {
                          return (
                            <div key={index} className="col">
                              <div
                                className="alert alert-dark alert-dismissible fade show"
                                role="alert"
                                style={{ width: "100px" }}
                              >
                                {item?.description}
                                <button
                                  type="button"
                                  className="btn-close"
                                  data-bs-dismiss="alert"
                                  aria-label="Close"
                                ></button>
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  </div>
                </div>

                {/* Pruebas */}
                {location.state && (
                  <div className="row mt-5">
                    <div className="col">
                      <h6>Pruebas</h6>
                      <div className="row">
                        <div className="col-md-7 col-lg-4">
                          <p className="mt-4">Sube tu propia prueba</p>
                          <div className="row">
                            {/*Descripcion Test */}
                            <div className="job-header__bottom-left">
                              <ul>
                                <strong>Descripción: </strong> <br />
                                {testdes}
                              </ul>
                            </div>

                            <div className="col-md-6">
                              <label>
                                <button
                                  href="#"
                                  id="buttonvacante"
                                  className="btn btn--purple "
                                  data-bs-toggle="modal"
                                  data-bs-target="#Subir-test"
                                  data-title="test"
                                  type="button"
                                >
                                  Subir Prueba
                                </button>
                              </label>
                              <div className="mt-3 col-12">
                                <label>
                                  <button
                                    href="#"
                                    id="buttonDescargarvacante"
                                    className="btn btn--purple "
                                    type="button"
                                    disabled={!Notatest}
                                    onClick={Downloadtestvacant}
                                  >
                                    Descargar Prueba
                                  </button>
                                </label>
                              </div>
                            </div>
                          </div>
                        </div>
                        <span id="Notatest">
                          Nota: Los test es para 1 archivo, si tiene mas de un
                          test, debe comprimir los test y subirlo como un solo
                          archivo
                        </span>
                      </div>
                    </div>
                  </div>
                )}

                {/* Beneficios */}
                <div className="row mt-3">
                  <div className="col">
                    <p className="mt-5 mb-4">Beneficios</p>
                    <div className="">
                      <Field
                        as="textarea"
                        name="beneficios"
                        id="beneficios"
                        className="form-control"
                        required
                      ></Field>
                      {errors.beneficios && touched.beneficios && (
                        <span className="form__validation form__validation--error">
                          {errors.beneficios}
                        </span>
                      )}
                    </div>
                    <p className="m-st">Comentarios Adicionales</p>
                    <div className="">
                      <Field
                        as="textarea"
                        name="comentarios"
                        id="comentarios"
                        className="form-control"
                        required
                      ></Field>
                      {errors.comentarios && touched.comentarios && (
                        <span className="form__validation form__validation--error">
                          {errors.comentarios}
                        </span>
                      )}
                    </div>
                  </div>
                </div>

                {/* Estado de la vacante */}
                <div className="row mt-5">
                  <div className="col">
                    <h6>ESTADO DE LA VACANTE</h6>
                    <p className="mt-4">Personaliza el estado de vacante</p>
                    <div className="steps-box mb-4">
                      <div className="row">
                        <div className="col-md-6">
                          <p className="tit">
                            {vacant.companyVacant?.cargo ?? ""}
                          </p>
                          <p className="sub-tit">
                            {company.userId?.name ?? ""}
                          </p>
                        </div>
                        <div className="col-md-6 text-end">
                          <p className="sub-tit">
                            Fecha de Aplicación:{" "}
                            <span>
                              {vacant.companyVacant?.fechaPublicacion ??
                                date.toLocaleDateString()}
                            </span>
                          </p>
                          <p className="sub-tit">
                            Estado: <span>Activo</span>
                          </p>
                        </div>
                      </div>
                      <div className="process-wrapper">
                        <div id="progress-bar-container">
                          <ul className="estadoVacante">
                            {vacant.listEtapasVacante !== undefined ? (
                              vacant.listEtapasVacante.map((item, index) => {
                                return (
                                  <li
                                    key={index}
                                    className={
                                      item.completado
                                        ? "step stepA" + item.orden + " active"
                                        : "step stepA" + item.orden
                                    }
                                    onClick={() => {
                                      paintProgress(item.orden);
                                    }}
                                  >
                                    <div className="step-inner">
                                      <label
                                        htmlFor="#"
                                        id={"etapa" + item.orden}
                                      >
                                        {item.nombreEtapa}
                                      </label>
                                      <img
                                        src={edit_solid}
                                        className="img-fluid edit"
                                        data-bs-toggle="modal"
                                        data-bs-target="#editar-etapa-modal"
                                        onClick={() => {
                                          setlabelStep("etapa" + item.orden);
                                        }}
                                        alt="i-etapa"
                                      />
                                    </div>
                                  </li>
                                );
                              })
                            ) : (
                              <SteptsDefault setlabelStep={setlabelStep} />
                            )}
                          </ul>
                          <div id="line">
                            <div id="line-progress"></div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Cancelar | actualizar | publicar */}
                <>
                  <div
                    className="tab-pane fade"
                    id="pills-profile"
                    role="tabpanel"
                    aria-labelledby="pills-tab2"
                  >
                    ...
                  </div>

                  <div
                    className="tab-pane fade"
                    id="pills-contact"
                    role="tabpanel"
                    aria-labelledby="pills-tab3"
                  >
                    ...
                  </div>
                  <div className="row mb-4 text-end">
                    <div id="buttons" className="col-md-12">
                      {location.state && (
                        <LinkButton
                          type="button"
                          className="btn btn-light"
                          to={pathComplement + "/Vacante/EstadoVacantes"}
                        >
                          Cancelar
                        </LinkButton>
                      )}
                      <button
                        type="submit"
                        disabled={isSubmitting}
                        className="btn-deg1"
                        style={{
                          width: "250px",
                          height: "52px",
                        }}
                      >
                        {location.state !== undefined
                          ? "Actualizar"
                          : "Publicar"}
                      </button>
                    </div>
                  </div>
                </>
              </div>
            </Form>
          )}
        </Formik>
      )}

      {/* Etapa modal */}
      <ModalEtapa SetEtapa={SetEtapa} />

      {/* Idiomas Modal */}
      <ModalIdiomas listIdiomas={listIdiomas} SelectIdioma={SelectIdioma} />

      {/* Habilidades Modal */}
      <ModalHabilidades
        listHabilidades={listHabilidades}
        SelectHabilidad={SelectHabilidad}
      />

      <div
        id="Subir-test"
        className="kr-modal modal fade"
        tabIndex="-1"
        role="dialog"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <div className="modal-title"></div>

              <button
                type="button"
                className="close"
                data-bs-dismiss="modal"
                aria-label="close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="form form--white ">
                <div className="div__wrapper">
                  <div className="form__description text-center">
                    Subir Test
                  </div>

                  <div className="form-group p-3">
                    <label>Descripción</label>
                    <input
                      className="form-control"
                      value={testd.description}
                      rows={3}
                      onChange={({ target }) =>
                        setTestd({ ...testd, description: target.value })
                      }
                    />
                  </div>

                  <div className="form__row">
                    <div className="col-sm-12 col-md-8 px-3">
                      <label>Test</label>
                      <br />
                      <input
                        id="achivo-input"
                        type="file"
                        onChange={fileSelectHandler}
                      />
                    </div>
                  </div>
                  <div className="form__row">
                    <button onClick={onSubmit} className="btn btn--gradient">
                      Subir Test
                    </button>
                  </div>
                </div>
              </div>
              <span id="Notatest" hidden={!Notatest}>
                Nota: Ya hay un test subido en la vacante
              </span>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
}

function SteptsDefault({ setlabelStep }) {
  return (
    <>
      <li key="1" className="step stepA1 active">
        <div className="step-inner">
          <label htmlFor="#" id="etapa1" className="labelVacante">
            Publicacion de Vacante
          </label>
          <img
            src={edit_solid}
            className="img-fluid edit"
            data-bs-toggle="modal"
            data-bs-target="#editar-etapa-modal"
            onClick={() => {
              setlabelStep("etapa1");
            }}
            alt="vacnte-publica"
          />
        </div>
      </li>
      <li key="2" className="step stepA2">
        <div className="step-inner">
          <label htmlFor="#" id="etapa2" className="labelVacante">
            Recepción de Oferta
          </label>
          <img
            src={edit_solid}
            className="img-fluid edit"
            data-bs-toggle="modal"
            data-bs-target="#editar-etapa-modal"
            onClick={() => {
              setlabelStep("etapa2");
            }}
            alt="oferta-obtener"
          />
        </div>
      </li>
      <li key="3" className="step stepA3">
        <div className="step-inner">
          <label htmlFor="#" id="etapa3" className="labelVacante">
            Preselección
          </label>
          <img
            src={edit_solid}
            className="img-fluid edit"
            data-bs-toggle="modal"
            data-bs-target="#editar-etapa-modal"
            onClick={() => {
              setlabelStep("etapa3");
            }}
            alt="preseleccion"
          />
        </div>
      </li>
      <li key="4" className="step stepA4">
        <div className="step-inner">
          <label htmlFor="#" id="etapa4" className="labelVacante">
            Entrevista
          </label>
          <img
            src={edit_solid}
            className="img-fluid edit"
            data-bs-toggle="modal"
            data-bs-target="#editar-etapa-modal"
            onClick={() => {
              setlabelStep("etapa4");
            }}
            alt="entrevista"
          />
        </div>
      </li>
      <li key="5" className="step stepA5">
        <div className="step-inner">
          <label htmlFor="#" id="etapa5" className="labelVacante">
            Contratación
          </label>
          <img
            src={edit_solid}
            className="img-fluid edit"
            data-bs-toggle="modal"
            data-bs-target="#editar-etapa-modal"
            onClick={() => {
              setlabelStep("etapa5");
            }}
            alt="contratacion"
          />
        </div>
      </li>
    </>
  );
}

function ModalHabilidades({ listHabilidades, SelectHabilidad }) {
  const [habilidad, setHabilidad] = useState(null);
  return (
    <div
      className="kr-modal modal fade"
      id="agregar-habilidad-vacante-modal"
      tabIndex="-1"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-dialog-centered" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <div className="modal-title"></div>

            <div className="close" data-bs-dismiss="modal" aria-label="close">
              <span aria-hidden="true">&times;</span>
            </div>
          </div>

          <div className="modal-body">
            <div className="mb-4 row">
              <label htmlFor="habilidades" className="col-sm-2 pe-0">
                Habilidades
              </label>
              <div className="col-sm-10">
                <select
                  name="slSkills"
                  isClearable={true}
                  placeholder="Seleccione una habilidad"
                  onChange={(value) => setHabilidad(value.target.value)}
                  noOptionsMessage={() => "sin resultados"}
                  className="form-select form-select-sm"
                >
                  <option hidden>Seleccione una Habilidad</option>
                  {listHabilidades.map((item, index) => {
                    return (
                      <option key={index} value={item.skillId}>
                        {item.name}
                      </option>
                    );
                  })}
                </select>

                <button
                  className="btn-deg1"
                  onClick={() => SelectHabilidad(habilidad)}
                >
                  Agregar Habilidad
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

function ModalIdiomas({ listIdiomas, SelectIdioma }) {
  const [idioma, setIdioma] = useState(null);

  return (
    <div
      className="kr-modal modal fade"
      id="agregar-idioma-vacante-modal"
      tabIndex="-1"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-dialog-centered" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <div className="modal-title"></div>

            <div className="close" data-bs-dismiss="modal" aria-label="close">
              <span aria-hidden="true">&times;</span>
            </div>
          </div>

          <div className="modal-body">
            <div className="mb-4 row">
              <label htmlFor="languageId" className="col-sm-2 pe-0">
                Idiomas
              </label>
              <div className="col-sm-10">
                <select
                  id="languageId"
                  name="languageId"
                  className="form-select form-select-sm"
                  onChange={(e) => setIdioma(e.target.value)}
                >
                  <option hidden>Seleccione un Idioma</option>
                  {listIdiomas.map((item, index) => {
                    return (
                      <option key={index} value={item.id}>
                        {item.description}
                      </option>
                    );
                  })}
                </select>

                <button
                  className="btn-deg1"
                  onClick={() => SelectIdioma(idioma)}
                >
                  Agregar Idioma
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

function ModalEtapa({ SetEtapa }) {
  return (
    <div
      className="kr-modal modal fade"
      id="editar-etapa-modal"
      tabIndex="-1"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title" id="exampleModalLabel">
              Editar Etapa
            </h5>
          </div>
          <div className="modal-body">
            <input className="form-control" onChange={SetEtapa}></input>
          </div>
          <div className="modal-footer">
            <div
              data-bs-dismiss="modal"
              className="btn btn-light"
              style={{ borderRadius: "30px" }}
            >
              Cancelar
            </div>
            <div className="btn btn-info" data-bs-dismiss="modal">
              Aceptar
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Vacante;
